import axios from "../http_v2";
import accounts from "./account";
let bindlist = data => {
  return axios.post("opservice/wechatmanage/page", data);
};
let bindsave = data => {
  return axios.post("opservice/wechatmanage/save", data);
};
let binddel = data => {
  return axios.post("opservice/wechatmanage/delete", data);
};
let list = () => {
  return axios.get("opservice/userFormField/get/userFormBaseField");
};
let formList = () => {
  return axios.get("opservice/userFormField/get/form");
};
let save = param => {
  return axios.post("opservice/userFormField/save/formfield", param);
};
let remove = param => {
  return axios.get("opservice/userFormField/remove?id=" + param);
};
let update = param => {
  return axios.post("opservice/userFormField/update/formfield", param);
};
let getdata = params => {
  return axios.get("opservice/tenantconf/current", params);
};
let setdata = params => {
  return axios.post("opservice/tenantconf/save", params);
};
export default {
  bindlist,
  bindsave,
  binddel,
  list,
  formList,
  save,
  remove,
  update,
  getdata,
  setdata,
  accounts,
  // 小程序相关接口
  miniprogram: {
    // 生成小程序码
    createQRCode: params => {
      return axios.post("opservice/wx/app/wxACode", params);
    },
    // 更新小程序码
    updateQRCode: params => {
      return axios.post("opservice/wx/app/wxACode/update", params);
    }
  },
  // 公众号相关接口
  account: {
    scanList: params => {
      return axios.get("marketcenter/webchatcollocation/appList/page", params);
    },
    message: {
      list: params => {
        return axios.get("marketcenter/wxproxy/sendmsg_page", params);
      }
    }
  },
  media: {
    uploadByBase64: (params, appid) => {
      return axios.post(
        "/wxmp/wx/" + appid + "/media/uploadimg/base64",
        params
      );
    }
  },
  yxSetting: {
    get: (params, appid) => {
      return axios.get("/wxmp/wx/" + appid + "/custom/setting/get", params);
    },
    save: (params, appid) => {
      return axios.post("/wxmp/wx/" + appid + "/custom/setting", params);
    }
  }
};
